// extracted by mini-css-extract-plugin
export default {"root":"ixklR","white":"_3aT9g","themed":"_2l_hh"};